import { ErrorModalService } from './../service/error-modal.service';
import { Component } from '@angular/core';
import { CognitoService } from '../service/cognito.service'; // , IUser
import { OnInit,Inject, forwardRef } from '@angular/core' // NgModule, ViewChild
import { LocalStorageService } from '../local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { IotService } from '../service/iot.service';
import { ThemeService } from '../service/theme.service';
import { SystemMessageService } from '../service/system-message.service';
import { ChatService } from '../service/chat.service';

interface MarkerProperties {
  position: {
    lat: number;
    lng: number;
  }
};

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  public loading = true;

  constructor(
    public cognitoService: CognitoService,
    private localStorageService: LocalStorageService,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
    public theme: ThemeService,
    public systemMessage: SystemMessageService,
    public chatService: ChatService,
    private errorModal: ErrorModalService
    ){}

  async ngOnInit() {
    try {
      await this.cognitoService.confirmValidUser();
      await this.cognitoService.getUserType();
    } finally {
      this.loading = false;
    }
  /*   await this.chatService.initConversations(); */
  }


  async getMessage(): Promise<string>{
    const message = await this.systemMessage.getMessageText('iotModalViewDeviceHibernationST');
    return message;
  }

  initErrorModal(){
    this.errorModal.setShowErrorModal();
    this.errorModal.isShowErrorModal();
    this.errorModal.setErrorDetails("Error", "28 Chemin de la Côte Saint-Louis Ouest, suite 110-111, Blainville, Quebec J7C 1B8 28 Chemin de la Côte Saint-Louis Ouest, suite 110-111, Blainville, Quebec J7C 1B8")
  }
}
